<template>
  <div class="base-mit-multi-users">
      <v-card :outlined="outlined" :flat="flat">
          <v-card-title v-if="showTitle">
              {{title}}
          </v-card-title>
          <v-card-subtitle v-if="showTitle">
              {{subtitle}}
          </v-card-subtitle>
          <v-card-text>
              <v-row>
                <!-- <v-spacer></v-spacer> -->
                <v-col cols="8" class="pr-3">
                      <v-radio-group class="pa-0 ma-0" v-model="searchBy" row>
                        <!-- These values for the radios are tied to the url that gets sent and the model that gets returns
                        Its a little bit coupled and maybe bad because any changes will break it. The autocomplete also uses it to index the search results -->
                                <v-radio label="Search By Name" value="name"></v-radio>
                                <v-radio label="Search By CSAIL ID" value="id"></v-radio>
                      </v-radio-group>
                  </v-col>
              </v-row>
              <v-row no-gutters>
                  <v-col cols="8">
                      <v-autocomplete
                        class="ma-0"
                        outlined
                        :dense="dense"
                        :label="label"
                        color="primary"
                        v-model="searchSelectedUser"
                        :items="searchUserList"
                        :search-input.sync="userSearch"
                        :loading="loading"
                        loader-height="5"
                        :error-messages="searchErrorMessages"
                        :item-text="searchBy"
                        :return-object="true"
                        no-data-text="Enter text to get users..."
                        @change="searchChanged"
                        @input="inputChanged"
                      >
                          <template v-slot:item="data">
                              <v-list-item-content>
                                <v-list-item-title>{{data.item.id}}</v-list-item-title>
                                <v-list-item-subtitle>{{data.item.email}}</v-list-item-subtitle>
                                <v-list-item-subtitle>{{data.item.name}}</v-list-item-subtitle>
                              </v-list-item-content>
                          </template>
                          <template v-slot:append-outer>
                            
                              <!-- <v-icon color="primary" @click="addUser(searchSelectedUser)">mdi-plus-circle-outline</v-icon> -->
                              <!-- <v-icon :color="searchSelectedUser ? 'primary' : 'grey'" @click="addUser(searchSelectedUser)">mdi-account-plus</v-icon> -->
                              <!-- <v-icon v-if="searchSelectedUser" color="primary" @click="addUser(searchSelectedUser)">mdi-account-plus</v-icon>
                              <v-icon v-else color="grey">mdi-account-plus</v-icon> -->

                        </template>
                      </v-autocomplete>
                     
                  </v-col>
                  <!-- <v-col cols="4" class="pr-3">
                      <v-radio-group class="pa-0 ma-0" v-model="searchBy" row>
                                <v-radio label="Search By Name" value="name"></v-radio>
                                <v-radio label="Search By CSAIL ID" value="id"></v-radio>
                      </v-radio-group>
                  </v-col> -->
              </v-row>
              <v-row no-gutters>
                  <v-col cols="12">
                      <div>Selected Users:</div>
                      <v-list v-if="selectedUsers.length > 0" two-line outlined class="pt-0">
                          <v-list-item v-for="user in selectedUsers" :key="user.id">
                            <v-list-item-avatar>
                              <v-icon class="grey lighten-1" dark>
                                mdi-account
                              </v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title>{{user.name}}</v-list-item-title>
                              <v-list-item-subtitle>{{user.id}}</v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-btn icon @click="removeUser(user)">
                                <v-icon color="red lighten-1">mdi-delete</v-icon>
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                    </v-list>
                    <v-list v-else outlined class="pt-0">
                        <v-list-item style="color:grey;">
                            None.
                        </v-list-item>
                    </v-list>
                  </v-col>
              </v-row>
          </v-card-text>
      </v-card>




  </div>
</template>

<script>
import BaseMitCSAILLdapService from '../../services/BaseMitCSAILLdapService.js';

export default {
  name: 'BaseMitCSAILMultiUsers',
  components: {},
  props: {
    defaultSelectedUsers:{
         type: Array,
         default() {
             return []
         }
      },
    returnObject:{
      default: false,
      type: Boolean
    },
    dense:{
      default: true,
      type: Boolean
    },
    outlined:{
      default: true,
      type: Boolean
    },
    flat:{
      default: false,
      type: Boolean
    },
    label:{
        default: 'Search...',
        type: String
    },
    showTitle:{
      default: true,
      type: Boolean
    },
    title:{
        default: 'Select Users',
        type: String
    },
    subtitle:{
        default: 'Find and add users',
        type: String
    }
  },
  data: function() {
    return {
        loading:false,
        userSearchTerm:'',
        searchUserList:[],
        searchSelectedUser:null,
        searchErrorMessages:[],
        selectedUsers:[],
        searchBy:'name'
    }
  },
  created(){
      //look up the user info for any default selected users for this control.
      //This way we can show other info like full name.
      //This will only work by default, it won't work if users change the values after first render.
      if(this.defaultSelectedUsers.length > 0){
          this.populateDefaultUsers(this.defaultSelectedUsers);
      }
  },
  computed: {
      userSearch: {
        get () {
          return this.userSearchTerm
        },
        set (searchInput) {
          if (this.userSearchTerm !== searchInput) {
            this.userSearchTerm = searchInput
            this.getCsailUsers(this.userSearchTerm, this.searchBy);
          }
        }
      }
  },
  methods: {
      populateDefaultUsers(list){
          BaseMitCSAILLdapService.requestGetUsersInfo(list)
            .then((data) => {
              this.selectedUsers = data.users;
              this.$emit('user-changed',this.selectedUsers);
            })
            .catch((error) => {
                console.log('Failed to fetch initial users data.')
            });
      },
      checkUserAlreadyAdded(user){
          for(let x = 0; x < this.selectedUsers.length; x++){
              if(this.selectedUsers[x].id === user.id){
                  return true;
              }
          }

          return false;
      },
      searchChanged(item){
          //clear any error messages on a change.
          this.searchErrorMessages = [];
      },
      inputChanged(user){
        this.addUser(user);
        
        this.$nextTick(() => {
          //need to add a next tick, otherwise the autocomplete control does not realiably pick up the change
          this.searchSelectedUser = ''; //clear out the added user
        });
      },
      addUser(user){
          if(this.checkUserAlreadyAdded(user)){
              this.searchErrorMessages = ['User already added!'];
          }
          else{
              this.searchErrorMessages = [];
              this.selectedUsers.push(user);
              this.$emit('user-changed',this.selectedUsers);
          }

      },
      removeUser (user) {
        let index = -1;

        for(let x = 0; x < this.selectedUsers.length; x++){
          if(this.selectedUsers[x] === user.id || (this.selectedUsers[x].id && this.selectedUsers[x].id === user.id)){
            index = x;
            break;
          }
        }
        if (index >= 0) {
            this.selectedUsers.splice(index, 1);
            this.$emit('user-changed',this.selectedUsers);
        }

      },
      getCsailUsers(searchterm, searchBy){
            this.loading = true;
            BaseMitCSAILLdapService.requestGetUsers(searchterm, searchBy)
              .then((data) => {
                this.searchUserList = data.users;
                this.loading = false;
              })
              .catch((error) => {
                this.searchUserList = [];
                this.loading = false;
              });
      }
  }
}
</script>

<style lang="scss" scoped>
</style>
